import React from 'react';
import { VIEW_MODES, CALENDAR_VIEWS } from '../../constants/statuses';
import StatusFilter from './StatusFilter';
import SortDropdown from './SortDropdown';

const FilterTabs = ({ 
  view, 
  setView, 
  calendarView, 
  setCalendarView,
  selectedStatuses,
  onStatusChange,
  sortBy,
  onSortChange
}) => {
  return (
    <div className='dashboard-header'>
      <div className='filter-controls'>
        <div className='status-filter-container'>
          <StatusFilter 
            selectedStatuses={selectedStatuses}
            onStatusChange={onStatusChange}
          />
        </div>
        <div className='sort-filter-container'>
          <SortDropdown
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </div>
      </div>

      <div className='view-controls'>
        <div className='view-buttons'>
          <button
            className={view === VIEW_MODES.LIST ? 'active' : ''}
            onClick={() => setView(VIEW_MODES.LIST)}
          >
            📋 List
          </button>
          <button
            className={view === VIEW_MODES.CALENDAR ? 'active' : ''}
            onClick={() => setView(VIEW_MODES.CALENDAR)}
          >
            📅 Calendar
          </button>
        </div>
        
        {view === VIEW_MODES.CALENDAR && (
          <div className='calendar-view-buttons'>
            <button
              className={calendarView === CALENDAR_VIEWS.MONTH ? 'active' : ''}
              onClick={() => setCalendarView(CALENDAR_VIEWS.MONTH)}
            >
              Month
            </button>
            <button
              className={calendarView === CALENDAR_VIEWS.MULTI_MONTH_STACK ? 'active' : ''}
              onClick={() => setCalendarView(CALENDAR_VIEWS.MULTI_MONTH_STACK)}
            >
              Stack
            </button>
            <button
              className={calendarView === CALENDAR_VIEWS.YEAR ? 'active' : ''}
              onClick={() => setCalendarView(CALENDAR_VIEWS.YEAR)}
            >
              Year
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterTabs;
